import React, { useState, useCallback, useEffect, useContext } from 'react'
import Script from 'next/script'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { googleApiKey } from '../../../../utils/constants';
import { LocationContext } from '../../../../context/LocationContext';
import { criteriaSentence } from '../../../../js/criteria-phrase';
import { SystemError } from '../../../error/SystemError';
import { calculateAirconServiceCost } from '../../../../api/aircon-service/aircon-service-api';

export const AirconServiceCostCalculator = (props) => {
    const requestCategorySettings = props.requestCategorySettings
    const isServiceProvider = props.isServiceProvider

    const requestType = "Aircon Services"
    const [ requestSelection, setRequestSelection ] = useState([]);
    const [ choices, setChoices ] = useState([]); 
    const [ question, setQuestion ] = useState("");

    const [ minDate, setMinDate ] = useState("")
    const [ maxDate, setMaxDate ] = useState("")
    const [ displayServiceDate, setDisplayServiceDate ] = useState("")

    const [ criteria, setCriteria ] = useState("");
    const [ inputType, setInputType ] = useState("");
    const [ nextQuestionCode, setNextQuestionCode ] = useState("")
    const [ questionsList, setQuestionsList ] = useState("");
    const [ questionCode, setQuestionCode ] = useState("");
    const [ serviceDate, setServiceDate ] = useState("")
    const [ startTime, setStartTime ] = useState("13:00")
    const [ endTime, setEndTime ] = useState("15:00")

    const [ isCalculateCost, setIsCalculateCost ] = useState(false)     

    const [ isSystemError, setIsSystemError ] = useState(false)
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})  

    const changeCriteria = (choice) => {
        setCriteria(choice.value);
        setNextQuestionCode(choice.next_question_code)
    };
   
    const setNextQuestion = (nextQuestionCode) => {        
        if ( nextQuestionCode === "none"){
            setIsCalculateCost(true);
            setNextQuestionCode(nextQuestionCode)
        } else {
            for(let i in questionsList){
                if(questionsList[i].question_code === nextQuestionCode){
                    setQuestion(questionsList[i].question);
                    setQuestionCode(questionsList[i].question_code);
                    setChoices(questionsList[i].choices);
                    setInputType(questionsList[i].inputType);
                    if(questionsList[i].inputType !== 'list'){
                        setNextQuestionCode(questionsList[i].next_question_code)
                    } else {
                        setCriteria(questionsList[i].choices[0].value);
                        setNextQuestionCode(questionsList[i].choices[0].next_question_code)
                    }
                    if( questionsList[i].inputType == 'location'){
                        setGoogleAutoComplete(true);
                    }
                }
            }            
        }
    }
   
    const addCriteria = (e) => {	        
        e.preventDefault()     
        if ( criteria != ""){	 

            let criteriaPhrase = criteriaSentence(questionCode, requestType, criteria);
            
            let requestCriteriaW

            if(inputType === "date"){
                const date = new Date(criteria)
                requestCriteriaW = 
                {
                    'criteria': criteriaPhrase,
                    [questionCode]: date
                }
            } else {
                requestCriteriaW = 
                {
                    'criteria': criteriaPhrase,
                    [questionCode]: criteria
                }
            }
            setRequestSelection(requestSelection => [...requestSelection, requestCriteriaW])
            setCriteria("");
            setNextQuestion(nextQuestionCode);	
            		 
        } else {
            //if( question == ""){
            //	  goToSection3();
            // }else {
                skipCriteria(nextQuestionCode);
            // }
        }
    }
        
    const skipCriteria = () => {
        setCriteria("");
        setNextQuestion(nextQuestionCode);
    }
       
    const updateResponse = (e) =>{
        setCriteria(e.target.value)
    }

    const handleDateChange = (e) =>{
        setCriteria(e.target.value)
    }
       
    const filterSelection = useCallback(() => {	
        for (let temp in requestCategorySettings){
            if (requestCategorySettings[temp].requestType == requestType){
                setQuestionsList(requestCategorySettings[temp].criteriaQuestions)
                setQuestion(requestCategorySettings[temp].criteriaQuestions[0].question);
                setQuestionCode(requestCategorySettings[temp].criteriaQuestions[0].question_code)
                setChoices(requestCategorySettings[temp].criteriaQuestions[0].choices);
                setInputType(requestCategorySettings[temp].criteriaQuestions[0].inputType);
                if(requestCategorySettings[temp].criteriaQuestions[0].inputType != "list"){
                    setNextQuestionCode(requestCategorySettings[temp].criteriaQuestions[0].next_question_code)
                } else {
                    setCriteria(requestCategorySettings[temp].criteriaQuestions[0].choices[0].value);
                    setNextQuestionCode(requestCategorySettings[temp].criteriaQuestions[0].choices[0].next_question_code)
                }
            }
       }
    }, [requestType, requestCategorySettings, setNextQuestionCode])	 

    useEffect(() => {
        setIsCalculateCost(false)
        setRequestSelection([])
        filterSelection();  
        //setIsLoading(false);
    }, [requestCategorySettings, requestType, setRequestSelection, filterSelection])

    const reset = useCallback(() => {
        setIsCalculateCost(false)
        setRequestSelection([])
        filterSelection(); 
    }, [filterSelection])

    const resetCalculator = () => {
        reset()
    }
    
    const costCalculatorApi = useCallback(async() => {
        if(requestSelection.length === 0) return
        try {
            const response = await calculateAirconServiceCost(null, JSON.stringify(requestSelection), serviceDate, startTime, endTime)
            setIsCalculateCost(false)
            const servicingCost = (response.servicingCost - response.servicingCost*response.discountPercent/100).toFixed(2)
            if(!isServiceProvider){
                setErrorContent({'header': "Aircon Service Cost", 'body': "The total servicing cost should be around $" + servicingCost 
                + " for your requirements." + (response.gasCost?.highRange ? (" Gas cost is in between $" +  response.gasCost?.lowRange + " - $" + response.gasCost?.highRange) : " No gas refill.")});
            } else {
                let total = response.servicingCost
                if(response.gasCost?.lowRange){
                    total = total + (response.gasCost?.lowRange + response.gasCost?.highRange)/2
                }
                let earning = total - total*0.15 - (total*0.034)
                setErrorContent({'header': "Estimated Earning $" + earning.toFixed(2) , 'body': "Your estimated earning is around $" + earning.toFixed(2)
                + ". This estimation does not consider any discounts to the client and platform fees may vary."});
            }
            setIsSystemError(true)
            reset()
        } catch (error) {
            setIsCalculateCost(false)
            reset()
            setErrorContent({'header': "Error calculating cost", 'body': "Please refresh and try again."});
            setIsSystemError(true) 
        }
    }, [requestSelection, isServiceProvider, reset, serviceDate, startTime, endTime])

    useEffect(() => {
        if(!isCalculateCost || requestSelection.length === 0) return
        costCalculatorApi()
    }, [isCalculateCost, costCalculatorApi, requestSelection])

    useEffect(() => {
        const minD = new Date()
        // minD.setDate(minD.getDate() + 1)
        setMinDate(minD.toLocaleString( 'sv', { timeZoneName: 'short' } ).substring(0,10))
        
        const sDate = new Date()
        sDate.setDate(sDate.getDate() + 3)
        setServiceDate(sDate.toLocaleString( 'sv', { timeZoneName: 'short' } ).substring(0,10))
        setDisplayServiceDate(sDate.toUTCString().substring(0,16))

        const maxD = new Date()
        maxD.setDate(maxD.getDate() + 182)
        setMaxDate(maxD.toLocaleString( 'sv', { timeZoneName: 'short' } ).substring(0,10))

    }, [setServiceDate])

  return (    
    <>
        <div className="w-full">
            {/* <div className="text-center text-orange-600 text-xl">
                <h1>Help us understand your request better</h1>
            </div> */}            
            <form className="max-w-2xl mx-auto p-6 text-white bg-slate-800 rounded-lg">  
                <div className="my-2">
                    <span className="text-base">{question}</span>
                </div>
                {question == "" && 
                    <h3 className="">
                        <i>Anything else you want us to include?</i>
                    </h3>
                }
                {question ?
                    <div className="py-2">
                        {choices.length > 0 ?
                            <div id="choices" className='space-y-2'>
                                {[...choices].map((choice, i) =>                              
                                    <div key={i} className="radio">
                                        <label className="input-container">
                                            <input type="radio" name="optCriteria" checked={choice.value === criteria} value={choice.value} onChange={() => changeCriteria(choice)}/>{choice.value}
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                )} 
                            </div>
                            :
                            <>    
                                { inputType === 'open' && 
                                    <div>                            
                                        <input
                                            type="text"
                                            className="text-sm px-3 py-3 text-orange-600 w-full shadow appearance-none border rounded  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                                            placeholder={question} name="userId" value={criteria} onChange={(e) => updateResponse(e)}
                                            style={{ transition: "all .15s ease" }}
                                        />
                                    </div>
                                }                               
                                { inputType == 'location' && 
                                    <div>
                                        <input
                                            type="text" id="searchLocationField"
                                            className="text-sm px-3 py-3 text-orange-600 w-full shadow appearance-none border rounded  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                                            placeholder={question} name="userId" value={criteria} onChange={(e) => updateResponse(e)}
                                            style={{ transition: "all .15s ease" }}
                                            />
                                    </div>
                                }
                                {  inputType == 'date' && 
                                    <div>
                                        <input type="date" value={criteria} min={minDate} max={maxDate}
                                        className="indent-2 h-12 w-48 px-2 text-orange-600 text-lg bg-white shadow border rounded  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200" 
                                        name="serviceDate" onChange={(e) => handleDateChange(e)} required/>
                                    </div>
                                }                            
                            </>
                        }
                    </div>
                    :                
                    <div className="mt-2">
                        <input
                            type="text"
                            className="text-sm text-orange-600 px-3 py-3 w-full shadow appearance-none border rounded  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                            placeholder="Additional criteria (optional)" value={criteria} onChange={(e) => updateResponse(e)}
                            style={{ transition: "all .15s ease" }}
                            />
                    </div>                
                }                  
                
                <div className="flex justify-between pt-5">
                {question ? 
                    <>                          
                        {/* <button type="button"
                        className="px-4 py-2 text-lg border border-amber-400 rounded text-orange-600 font-bold" onClick={skipCriteria}>Skip</button> */}
                        <button className="text-lg bg-gray-50 text-orange-600 px-3 py-2 rounded-2xl border" type="button" onClick={() => resetCalculator()}>
                            Reset
                        </button>
                        <button 
                            className="text-lg font-bold px-6 py-3 bg-linear-to-t from-orange-600 to-amber-400 text-white hover:from-amber-500 hover:to-amber-400 focus:from-orange-400 focus:to-amber-300 rounded-2xl drop-shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-amber-400 ring-amber-200" 
                            type="submit" onClick={(e) => addCriteria(e)}>
                            Next
                        </button>				
                    </>
                    :
                    <button type="button"
                        className="px-4 py-2 border border-amber-400 rounded text-orange-600 font-bold" onClick={(e) => addCriteria(e)}>Add
                        Criteria
                    </button>
                }                    
                </div>
            </form> 
            
        </div>
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
    </>
  )
}
